import classNames from 'classnames';
interface Props {
  className?: string;
}
const HeaderBannerSkeleton = ({
  className
}: Props) => {
  return <div className={classNames('h-10 w-full animate-pulse bg-gray-100 lg:h-[60px]', className)} data-sentry-component="HeaderBannerSkeleton" data-sentry-source-file="skeleton.tsx" />;
};
export default HeaderBannerSkeleton;